module.exports = __webpack_public_path__ + "img/doctors hospital reinassance.77d76821.png";